import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ProjectSchemaType } from '@/global/schemas/project.schema';
import type { ProjectSG } from '@/global/types/project.type';

import { REDUX_SLICE } from '../constants';
import { ProjectSliceState } from '../types/project.type';

const initialState: ProjectSliceState = {
  project: null,
  projectInfo: null,
};

export const projectSlice = createSlice({
  name: REDUX_SLICE.PROJECT,
  initialState,
  reducers: {
    setProject: (state, action: PayloadAction<ProjectSG | null>) => {
      state.project = action.payload;
    },
    setProjectInfo: (state, action: PayloadAction<ProjectSchemaType | null>) => {
      state.projectInfo = action.payload;
    },
  },
});
